import React from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  stepperRoot: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '0px',
      paddingRight: '0px',
    },
  },
}));

export default function EntryStepper(props) {
  const classes = useStyles();
  const { activeStep, steps } = props;

  return (
    <Stepper alternativeLabel activeStep={activeStep} className={classes.stepperRoot}>
      {steps.map((step) => (
        <Step key={steps.id}>
          <StepLabel>{step.label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
